// extracted by mini-css-extract-plugin
module.exports = {"container":"Results_container__1WEDZ"};